import { useAtomValue } from 'jotai';

import { getIsAnyChatDrawerOpen } from '../../components/utils';
import { useChatDrawerButtonUtils } from '../chat/useChatDrawerButtonUtils';
import { drawerStateAtom } from '../state';
import { ChatDrawerControlMenuItem } from './ChatDrawerControlMenuItem';

export function ChatDrawerControlMenuItemWrapper() {
  const { unreadMessageCount, toggleChatDrawer } = useChatDrawerButtonUtils();
  const isChatDrawerOpen = getIsAnyChatDrawerOpen(useAtomValue(drawerStateAtom));

  return (
    <ChatDrawerControlMenuItem
      isChatDrawerOpen={isChatDrawerOpen}
      isChatButtonDisabled={false}
      onClick={toggleChatDrawer}
      unreadMessageCount={unreadMessageCount}
    />
  );
}
